import { LANG } from '@/libs/translation';
import { type Html, html, View } from 'rune-ts';
import { z } from 'zod';
import * as resources from './resources';
import { keys, pipe, map, fromEntries } from '@fxts/core';

const type = pipe(
  resources,
  keys,
  map((key) => [key, key] as [keyof typeof resources, keyof typeof resources]),
  fromEntries,
);

const terms_scheme = z.object({ type: z.nativeEnum(type), version: z.string().optional() });

export interface TermsData extends z.infer<typeof terms_scheme> {}

export class Terms extends View<TermsData> {
  static resources = resources;
  static terms_scheme = terms_scheme;

  body: Html;

  constructor(data: TermsData) {
    super(data);

    this.body =
      resources[this.data.type]?.[LANG]?.[this.data.version ? `version_${this.data.version}` : 'latest'] ??
      resources[this.data.type]?.[LANG]?.latest ??
      resources[this.data.type]?.kr?.latest ??
      '';
  }

  override template() {
    return html`<div>${this.body}</div> `;
  }
}
